module.exports = __webpack_public_path__ + "img/4_149.9790f11c.png";